export default (app, routeName) => {
  return {
    matchRoute: /^app-DV11/,

    mixin: {
      data() {
        return {
          Charts: {},
        }
      },
      methods: {
        loadConfig() {
          let { name, query } = this.$route
          let obj = {
            name: name.split("-")[1],
            query: query
          }
          this.$curl.get('/api/bigscreen/configData1/getConfigData', obj).then(res => {
            let { moduleConfig } = res
            this.Charts = moduleConfig
            // console.log("结果", res)
            this.getModuleData(query, true)
            this.setTimer(query)

            /*
            this.Charts = res;
            let obj = {}
            let { Charts, Source, $refs } = this
            Object.keys(Charts).forEach(key => {
              if ($refs.DV.$refs[`${key}Loading`]) {
                $refs.DV.$refs[`${key}Loading`].$el.style.display = "none"
              }
              if ($refs.DV.$refs[key]) {
                $refs.DV.$refs[key].setConfig(Charts[key])
              
              }
            })
            */
          })
        },

        //调接口拿到每个模块的数据-改版
        getModuleData(query = {}, load = true) {
          let obj = {}
          let { Charts, $refs } = this
          Object.keys(Charts).map((key) => {
            let requestType = "get"
            let ele = Charts[key]
            let ele_query = ele.queryParam
            let flag = false
            if (ele.api) {
              if (Object.keys(query).length > 0 && ele_query.length > 0) {
                Object.keys(query).map(k => {
                  if (ele_query.indexOf(k) > -1) {
                    obj[k] = query[k]
                    flag = true
                  }
                })
              }
              if (load || flag) {

                this.$curl[requestType](ele.api, obj).then(async res => {
                  let string = `${key}Ctrl`
                  let option = ele.option
                  Object.keys(option).map(k => {
                    if (res[k] && k != "series") {
                      option[k].data = res[k]
                    } else if (res[k] && k == "series") {
                      res[k].map((itm, idx) => {
                        option[k][idx].data = res[k][idx]
                      })
                    }
                  })

                  if (typeof this[string] === "function") {
                    Charts[key] = await this[string](Charts[key])
                  }

                  if ($refs.DV.$refs[`${key}Loading`]) {
                    $refs.DV.$refs[`${key}Loading`].$el.style.display = "none"
                  }
                  if ($refs.DV.$refs[key]) {
                    $refs.DV.$refs[key].setConfig(Charts[key])
                  }
                })

              }
            }

          })
          this.getAllData(query)

          /** 
          *  res--并发请求回来的数据数组
          *  response_data--某个数据对象， 
          *  key--left1
          */
          /*
           let allRequest = []
           let self = this
           Object.keys(Charts).forEach(key => {
             let ele = Charts[key]
             let ele_query = ele.queryParam
             let obj = {}
             let requestType = "get"
             if (!ele.api) {
               return allRequest.push({
                 key,
                 getData: () => { }
               })
     
             }
             //对比路由参数和配置里筛选参数的关键字
             if (Object.keys(query).length > 0 && ele_query.length > 0) {
               Object.keys(query).map(k => {
                 if (ele_query.indexOf(k) > -1) {
                   obj[k] = query[k]
                 }
               })
             }
             allRequest.push({
               key,
               getData: () => self.$curl[requestType](ele.api, obj)
             })
           })
     
     
           Promise.all(allRequest.map(item => item.getData())).then(res => {
             res.forEach(async (response_data, index) => {
               let { key } = allRequest[index]
               let string = `${key}Ctrl`
               //组装option
               let option = Charts[key].option
               Object.keys(option).map((key) => {
                 if (response_data[key] && key != "series") {
                   option[key].data = response_data[key]
                 } else if (response_data[key] && key == "series") {
                   response_data[key].map((itm, idx) => {
                     option[key][idx].data = response_data[key][idx]
                   })
                 }
               })
               //执行自定义事件
               if (typeof this[string] === "function") {
                 Charts[key] = await this[string](Charts[key])
               }
               //隐藏加载div
               if ($refs.DV.$refs[`${key}Loading`]) {
                 $refs.DV.$refs[`${key}Loading`].$el.style.display = "none"
               }
               //画图
               if ($refs.DV.$refs[key]) {
                 $refs.DV.$refs[key].setConfig(Charts[key])
               }
     
             })
           })
     
           */



        },
        async getAllData(para = {}) {

          if (typeof this.customesData === "function") {
            let Obj = await this.customesData(para)
            let { Charts, $refs } = this
            Object.keys(Obj).map(key => {
              if (Charts.hasOwnProperty(key)) {
                let ele = Obj[key]
                let option = Charts[key].option
                Object.keys(option).map(k => {
                  if (ele[k] && k != "series") {
                    option[k].data = ele[k]
                  } else if (ele[k] && k == "series") {
                    ele[k].map((itm, idx) => {
                      option[k][idx].data = ele[k][idx]
                    })
                  }
                })
                if ($refs.DV.$refs[`${key}Loading`]) {
                  $refs.DV.$refs[`${key}Loading`].$el.style.display = "none"
                }
                if ($refs.DV.$refs[key]) {
                  $refs.DV.$refs[key].setConfig(Charts[key])
                }
              }
            })
          }
        },
        setTimer(query) {
          let { Charts, $refs } = this
          Object.keys(Charts).map((key) => {
            let ele = Charts[key]
            let requestType = "get"
            let obj = {}
            let ele_query = ele.queryParam

            if (ele.timer) {
              if (Object.keys(query).length > 0 && ele_query.length > 0) {
                Object.keys(query).map(k => {
                  if (ele_query.indexOf(k) > -1) {
                    obj[k] = query[k]
                    flag = true
                  }
                })
              }

              this[`timer-${key}`] = setInterval(() => {
                // console.log(key)
                this.$curl[requestType](ele.api, obj).then(async res => {
                  let string = `${key}Ctrl`
                  let option = ele.option
                  Object.keys(option).map(k => {
                    if (res[k] && k != "series") {
                      option[k].data = res[k]
                    } else if (res[k] && k == "series") {
                      res[k].map((itm, idx) => {
                        option[k][idx].data = res[k][idx]
                      })
                    }
                  })

                  if (typeof this[string] === "function") {
                    Charts[key] = await this[string](Charts[key])
                  }

                  if ($refs.DV.$refs[`${key}Loading`]) {
                    $refs.DV.$refs[`${key}Loading`].$el.style.display = "none"
                  }
                  if ($refs.DV.$refs[key]) {
                    $refs.DV.$refs[key].setConfig(Charts[key])
                  }
                })
              }, ele.timer)
            }
          })
        }
      },

      watch: {
        //监听路由，路由切换后，判断配置Charts里是否设置queryParam，设置的queryParam和当前url上的query是否相等，若相等则调用initChart再次初始化图表
        $route: {
          handler(to, from) {
            let { query } = to
            this.getModuleData(query, false)
          }
        }
      },

      mounted() {
        console.log("mixin进来了")
        this.$nextTick(() => {
          this.loadConfig();
        })
      },
      //清除定时器
      destroyed() {
        let { Charts } = this
        Object.keys(Charts).map((key) => {
          if(this[`timer-${key}`]){
            clearInterval(this[`timer-${key}`])
          }
        })
        console.log("清除定时器")

      }
    }
  }
}